<template>
<div class='hrmyReceiveResumeIndex'>
    <div class='cont' v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0)">
        <el-button icon="el-icon-plus" type="primary" @click="addHr">添加HR</el-button>
        <div class="tableCont">
            <el-table :data="hrList" border style="width: 100%">
                <el-table-column label="hr微信头像" align="center">
                    <template slot-scope="scope">
                        <img :src='scope.row.avatarPath' style="width:70px;height:70px;border-radies: 8px;border-radius: 8px;" />
                    </template>
                </el-table-column>
                <el-table-column prop="nickname" label="hr微信昵称" align="center">
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-popover placement="top" width="160" v-model="scope.row.visible">
                            <p style="font-weight: bold;padding-bottom:10px;">是否与该HR解除绑定</p>
                            <p style="color:red;padding-bottom:10px;">解绑HR需要指定该HR所发布职位的接收人员，如未指定则下架该HR所有职位</p>
                            <el-select style="padding-bottom:10px;" v-model="scope.row.jsId" placeholder="请选择接收人员">
                                <el-option
                                v-for="item in hrList"
                                :key="item.id"
                                :label="item.nickname"
                                :value="item.id"
                                v-if="scope.row.id !== item.id"
                                >
                                </el-option>
                                <el-option
                                key="null"
                                label="不指定"
                                value="null"
                                >
                                </el-option>
                            </el-select>
                            <div style="text-align: right; margin: 0">
                                <el-button size="mini" type="text" @click="popover(scope.$index, false)">取消</el-button>
                                <el-button type="primary" size="mini" @click="popover(scope.$index,  true)">确定</el-button>
                            </div>
                            <el-button type="text" size="small" slot="reference">
                                解除绑定
                            </el-button>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <div class="paginationBox">
            <el-pagination :page-size="hrPageSize" :pager-count="11" layout="prev, pager, next" :total="hrPageTotle" @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
    <el-dialog title="提示" :visible.sync="qrdialogVisible" width="30%">
        <img :src='QrUrl' style="margin: 0px auto;display: block;width:200px;height:200px" />
        <p style="text-align: center;">请在【聘快快企业版】小程序中，让HR选择【扫码绑定按钮】扫描该二维码完成HR的绑定</p>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="qrdialogVisible = false">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
let QRCode = require('qrcode')

export default {
    name: 'hrManagement',
    props: {},
    data() {
        return {
            hrList: [],
            hrPageNum: 1,
            hrPageSize: 11,
            hrPageTotle: 0,
            loading: false,
            QrUrl: '',
            qrdialogVisible: false
        }
    },
    watch: {},
    created: function () {},
    methods: {
        getHrList: function () {
            let that = this
            that.loading = true;
            let data = {
                pageNum: that.hrPageNum,
                pageSize: that.hrPageSize,
            }
            if (that.jobName !== '' && that.jobName !== 'all') {
                data.jobId = that.jobName
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise//admin/getHrUserList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: data,
            }).then((res) => {
                that.loading = false;
                if (res.data.success === '1') {
                    let list = res.data.content.list
                    for (let i = 0; i < list.length; i++) {
                        list[i].visible = false
                        list[i].jsId = 'null'
                    }
                    that.hrList = list
                    that.hrPageTotle = res.data.content.total
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.loading = false;
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        handleCurrentChange: function (e) {
            this.hrPageNum = e
            this.getHrList()
        },
        popover: function (index, status) {
            let list = this.hrList
            list[index]['visible'] = false
            if (status) {
                this.deleteHr(index)
            }
        },
        deleteHr: function (index) {
            let that = this
            let data = {
                    hrUserId: this.hrList[index].id
                }
            if (this.hrList[index].jsId !== 'null') {
                data.newUserId = this.hrList[index].jsId
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise//admin/relievebinding',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: data,
            }).then((res) => {
                that.loading = false;
                if (res.data.success === '1') {
                    that.$message.success('解绑成功');
                    that.getHrList()
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.loading = false;
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        addHr: function () {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise//admin/getAuthorizationCode',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                }
            }).then((res) => {
                that.loading = false;
                if (res.data.success === '1') {
                    QRCode.toDataURL(res.data.content, function (err, url) {
                        that.QrUrl = url
                        that.qrdialogVisible = true
                    })
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.loading = false;
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        }

    },
    mounted: function () {
        this.getHrList()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.hrmyReceiveResumeIndex {
    width: 100%;
    height: 100%;
    padding-top: 1px;
    position: relative;

    .cont {
        width: 100vw;
        overflow-x: scroll;
        height: calc(100% - 80px);
        background-color: #ffffff;
        border-radius: 8px;
        position: absolute;
        top: 50%;
        left: 50%;
        padding: 30px;
        box-sizing: border-box;
        transform: translate(-50%, -50%);
    // overflow: hidden;
    overflow-y: scroll;

        .selectCont {
            .el-select {
                .el-input {
                    color: #5DC2D0;

                    .el-input__inner {
                        background-color: transparent;
                        border: none;
                        color: #5DC2D0;

                        &::-webkit-input-placeholder {
                            color: #5DC2D0;
                        }
                    }

                    .el-select__caret {
                        color: #5DC2D0;
                    }
                }
            }
            .el-radio-group {
                margin-left: 40px;

                .el-radio-button__inner {
                    background-color: transparent;
                    color: #5DC2D0;
                }

                .is-active {
                    .el-radio-button__inner {
                        background-color: #5DC2D0;
                        color: #fff;
                        border-color: #5DC2D0;
                    }
                }
            }
        }

        .tableCont {
            margin-top: 30px;

            * {
                background-color: transparent;
                color: #5DC2D0;
            }

            .el-table--group,
            .el-table--border {
                border: none;

                &:after {
                    border: none;
                }
            }

            .el-table--group,
            .el-table--border {
                border: none;
            }

            .el-table--border th,
            .el-table--border td {
                border: none;
            }

            .el-table--group::after,
            .el-table--border::after,
            .el-table::before {
                height: 0;
                width: 0;
            }

            .el-table__header-wrapper {
                border-bottom: 1px solid #5DC2D0;
            }

            .el-table__body tr {
                >td {
                    span {
                        margin: 0 5px;
                    }
                }

                &:hover {
                    >td {
                        background-color: #5DC2D0;

                        div {
                            color: #ffffff;
                        }

                        span {
                            color: #ffffff;
                            margin: 0 5px;
                        }
                    }
                }
            }
        }

        .paginationBox {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            position: fixed;
            bottom: 100px;;
            left: 50%;
            transform: translateX(-50%);
            background-color: #ffffff;
            width: max-content;
            padding: 5px 40px;
            z-index: 9999;
            border-radius: 10px;

            .el-pager {
                li {
                    background: transparent;
                    color: #5DC2D0;
                }

                .active {
                    background: #fff;
                    color: #5DC2D0;
                }
            }

            .el-pagination .btn-prev,
            .el-pagination .btn-next {
                background-color: transparent;

                i {
                    color: #ffffff;
                }
            }
        }
    }
}
</style>
